import { styled } from '@mui/material';

import { PrototypeVerdict, Skeleton } from '@app-velocity/ui';

import { InfoSection } from '../../../../components/InfoSection';
import { Explanation } from './components/Explanation';
import { useReportContext } from '../../../../context/useReportContext';

const VerdictContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column',
  textAlign: 'center',
  gap: theme.spacing(2),
  flex: 1,
}));

export const PrototypeDecision = () => {
  const { statistics, isLoading, renderRequirements } = useReportContext();
  const { meetsRequirements } = statistics;

  return (
    <InfoSection tooltip="prototypes:report.decision.tooltip">
      <InfoSection.Title title="prototypes:report.decision.title" />

      <VerdictContainer>
        <span />
        {isLoading ? (
          <Skeleton height={80} width={138} />
        ) : (
          <PrototypeVerdict success={meetsRequirements} variant="big" />
        )}
        <Explanation />
        {isLoading ? (
          <Skeleton height={19} width={240} />
        ) : (
          renderRequirements?.() ?? null
        )}
      </VerdictContainer>
      <span />
    </InfoSection>
  );
};
